import { render, staticRenderFns } from "./AcceptInvitation.vue?vue&type=template&id=67864ec2&"
import script from "./AcceptInvitation.vue?vue&type=script&lang=ts&"
export * from "./AcceptInvitation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports